<template>
  <div v-show="fileList.length > 0 || showimglist.length > 0" class="upload-view">
    <div class="upload-view-bacckground">
      <div v-for="(item, index) in fileList" :key="index" class="file-item">
        <div v-if="item.status === 'uploading'" v-loading="true"
          class="icon-img" />
        <img v-else-if="item.status === 'success'" class="icon-img" :src="addtype(item.fileType)">
        <img v-else-if="item.status === 'failed'" class="icon-img" src="../images/icon_warning_r.svg">
        <div class="file-name">
          <span class="name">{{ item.name }}</span>
          <span class="type">.{{ item.fileType }}</span>
        </div>
        <div class="del-wrap">
          {{ item.Bytes }}
          <img class="icon-img del-icon" src="../images/icon_close_b.svg" @click="deleteFile(item, index)">
        </div>
      </div>
      <div v-if="showimglist.length > 0" class="img-wrap">
        <el-upload v-model="showimglist" list-type="picture-card" :auto-upload="false" action="" multiple
          :file-list="imgList">
          <template #file="{file}">
            <img class="el-upload-list__item-thumbnail" :src="file.url">
            <div v-if="file.status == 'uploading'" v-loading="true"
              element-loading-background="rgba(0, 0, 0, 0.6)" class="el-upload-list__item-loading" />
            <img v-if="file.status == 'success'" class="el-upload-list__item-success" src="../images/icon_ok.png">
            <!-- 上传失败 -->
            <div v-if="file.status == 'failed'" class="el-upload-list__item-failed-text">
              上传失败
            </div>
            <span v-if="file.status !== 'uploading'" class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <img class="upload-icon-zoom-delete" src="../images/icon_zoom_in.svg">
              </span>
              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                <img class="upload-icon-zoom-delete" src="../images/icon_delete.svg">
              </span>
            </span>
          </template>
        </el-upload>
      </div>
      <!-- 图片预览器 -->
      <el-image-viewer v-if="dialogVisible" :url-list="[dialogImageUrl]" :z-index="1000"
        @close="() => dialogVisible = false" />
    </div>
  </div>
</template>

<script>

import iconPdf from "../images/icon_pdf.svg";
import iconXls from "../images/icon_xls.svg";
import iconDoc from "../images/icon_doc.svg";
import iconPpt from "../images/icon_ppt.svg";
import iconTxt from "../images/icon_txt.svg";
export default {
  name: "UploadFile",
  components: {},
  props: {
    imgList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    uploadFileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    showimglist: {
      get() {
        return this.imgList || [];
      },
      set(imgList) {
        this.$emit("update:imgList", imgList);
      }
    }
  },
  mounted() { },
  methods: {
    // 给文件添加展示图标
    addtype(suffix) {
      if (suffix.includes("pdf")) {
        return iconPdf;
      } else if (suffix.includes("xls")) {
        return iconXls;
      } else if (suffix.includes("doc")) {
        return iconDoc;
      } else if (suffix.includes("ppt")) {
        return iconPpt;
      } else if (suffix.includes("txt")) {
        return iconTxt;
      }
    },
    handlePictureCardPreview(file) {
      console.log("🚀 ~ handlePictureCardPreview ~ file:", file);
      this.dialogImageUrl = file.previewUrl;
      this.dialogVisible = true;
    },
    deleteFile(file, index) {
      this.fileList.splice(index, 1);
      this.$emit("deleteUploadFileList", file);
    },
    handleRemove(file) {
      const index = this.imgList.findIndex(item => { return item.uid == file.uid; });
      this.imgList.splice(index, 1);
      this.$emit("deleteUploadFileList", file);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-upload--picture-card {
  grid-template-columns: repeat(5, 1fr);
  gap: 5px 5px;
}

::v-deep .el-upload--picture-card {
  display: none;
}

.upload-view {
  // position: absolute;
  // top: 0;
  // right: 0px;
  text-align: -webkit-right;
  padding: 10px 16px 16px 0;
  box-sizing: border-box;

  .upload-view-bacckground {
    background-color: white;
    border-radius: 10px;
    width: fit-content;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
  }
}

.file-item {
  overflow: hidden;
  width: 320px;
  height: 40px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  margin: 0 12px;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;

  .file-name {
    width: 100%;
    color: #323232;
    font-size: 12px;
    text-align: left;
    flex: 1;
    padding-left: 8px;
    padding-right: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;

    .name {
      flex: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .type {
      flex: none;
    }
  }

  .del-icon {
    flex: none;
    padding-left: 8px;
  }

  .del-wrap {
    flex: none;
    font-size: 10px;
    color: #969696;
    display: flex;
    align-items: center;
    padding-left: 8px;
    border-left: 1px solid #e5e5e5;
  }

  .icon-img {
    width: 16px;
    height: 16px;
    ::v-deep .el-loading-spinner {
      top: -2px;
      margin: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .circular{
        width: 100%;
        height: 100%;
      }
    }
  }
}

.img-wrap {
  width: fit-content;
  padding: 12px;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;

  ::v-deep .el-upload-list__item {
    width: 62px;
    height: 62px;
    border-radius: 6px;
    margin: 0 4px 0 0;

    &:last-child {
      margin: 0;
    }

    &:hover {

      .el-upload-list__item-failed-text,
      .el-upload-list__item-success {
        display: none;
      }
    }

    .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .el-upload-list__item-loading {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;

      .el-loading-spinner {
        position: absolute;
        top: 0;
        left: 0;
        margin-top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        &>i {
          color: #fff;
        }
      }
    }

    .el-upload-list__item-success {
      position: absolute;
      top: 0;
      right: 0;
      width: 19px;
      height: 19px;
    }

    .el-upload-list__item-failed-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #FFFFFF;
      text-align: center;
      font-family: PingFangSC-Regular;
      line-height: 12px;
      font-weight: 400;
    }

    .el-upload-list__item-actions {
      justify-content: center;
      .upload-icon-zoom-delete{
        width: 14px;
        height: 14px;
      }

      &>span {
        margin: 5px;
        font-size: 14px;
      }
    }
  }
}
</style>
